import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import 'mapbox-gl/dist/mapbox-gl.css'
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { printRouteGuardBootMarker } from '@/utils/routeWriteAudit';
import {
  clearStaleBuildReloadFlag,
  isModuleLoadError,
  recoverFromStaleBuild,
  shouldReloadForStaleBuild,
} from '@/utils/retryImport';

// Initialize PWA Elements for Capacitor plugins (Camera, etc.)
defineCustomElements(window);

printRouteGuardBootMarker('frontend');

/**
 * Vite fires `vite:preloadError` when a hashed chunk referenced by the current
 * build is no longer on the CDN (i.e. a newer deployment replaced it). Recover
 * by reloading once per session instead of surfacing a dead-end error screen.
 */
window.addEventListener('vite:preloadError', (event) => {
  if (shouldReloadForStaleBuild()) {
    event.preventDefault();
    void recoverFromStaleBuild();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (isModuleLoadError(event.reason) && shouldReloadForStaleBuild()) {
    void recoverFromStaleBuild();
  }
});

createRoot(document.getElementById("root")!).render(<App />);

// The app booted with the current asset set; allow a future deployment to
// trigger a fresh one-shot recovery reload.
window.setTimeout(clearStaleBuildReloadFlag, 5000);

